const AbstractItem = require('@/lib/Items/AbstractItem');
const ItemType = require('@/lib/Items/ItemType');
const { normalizeBarcode } = require('@/lib/Barcodes');
const { populate } = require('@/functions/objects');
const { toBool, toNullableIntArray, toString } = require('@/functions/transform');

class Product extends AbstractItem {
    constructor(data = {}) {
        super();

        /**
         * @type {string}
         */
        this.code = '';

        /**
         * @type {boolean}
         */
        this.isFood = false;

        this.itemType = ItemType.PRODUCT;

        /**
         * @type {boolean}
         */
        this.requiresDelivery = false;

        /**
         * Show this product on the kitchen screen(s)?
         *
         * @type {boolean}
         */
        this.showOnKitchenScreen = false;

        /**
         * Which Kitchen Zone(s) this product will appear on, if kitchen screens are in use.
         * This is used in combination with showOnKitchenScreen.
         * If showOnKitchenScreen is false, the product will not appear on any kitchen screens.
         * If showOnKitchenScreen is true and this is null, the product will appear on all kitchen screens.
         * If showOnKitchenScreen is true and this is an array, the product will appear only on those kitchen screens.
         *
         * @type {?number[]}
         */
        this.kitchenZoneIDs = null;

        populate(this, data);
    }

    /**
     * @return {object}
     */
    getHydrationMap() {
        return Object.assign(
            super.getHydrationMap(),
            {
                code: toString,
                isFood: toBool,
                kitchenZoneIDs: toNullableIntArray,
                showOnKitchenScreen: toBool,
                requiresDelivery: toBool,
            }
        );
    }

    afterHydration(data = {}) {
        super.afterHydration(data);

        // Some clients have their barcodes set in the code field instead.
        // Some of those have a *lot* of products, and it would be a lot of work to fix manually.
        // It could be fixed with a migration, but they can still mess it up again after that.
        // So we'll be helpful here. Allow using the product code as the barcode.
        if (this.code) {
            this.barcodes.push(normalizeBarcode(this.code));
        }
    }

    /**
     * @param {number} kitchenZoneID
     *
     * @returns {boolean}
     */
    showInKitchenZone(kitchenZoneID) {
        if (!this.showOnKitchenScreen) {
            return false;
        }

        if (this.kitchenZoneIDs === null) {
            return true;
        }

        return this.kitchenZoneIDs.includes(kitchenZoneID);
    }
}

module.exports = Product;
